'use client';
import './styles.css';
import Image from 'next/image';
import arrow from '@images/icon_arrow.svg';
import hero1 from '@images/company-hero1.webp';
import hero2 from '@images/company-hero2.webp';
import hero3 from '@images/company-hero3.webp';
import hero4 from '@images/company-hero4.webp';
import { useEffect, useState } from 'react';

const AnimatedArrow = () => (
  <Image
    src={arrow}
    alt=""
    width={24}
    className="animate absolute bottom-[7%] left-[calc(50%-12px)] cursor-pointer"
    onClick={() => {
      window.scrollTo({
        top: window.scrollY + window.innerHeight,
        behavior: 'smooth',
      });
    }}
  />
);

const FadeBackground = () => {
  const images = [hero1, hero2, hero3, hero4];
  const [currentImageIdx, setCurrentImageIdx] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentImageIdx(prevIndex => (prevIndex + 1) % images.length);
    }, 5000);
    return () => clearInterval(intervalId);
  }, [images.length]);

  return (
    <div className="relative bottom-0 h-[100vh] w-full bg-3b-blue-light-900 object-cover object-bottom 2xl:object-contain">
      <div className="relative flex aspect-[960/461] h-[100vh] w-full overflow-hidden">
        <Image
          src={images[currentImageIdx]}
          alt={''}
          className="fade-bg h-[100vh] w-full object-cover object-bottom 2xl:object-contain"
          priority
        />
      </div>
    </div>
  );
};

export const HeroBackground = ({ children }: { children: React.ReactNode }) => (
  <>
    <FadeBackground />
    {children}
    <AnimatedArrow />
  </>
);
